/**
 * Created by Ning Jiang on 10/19/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneWildSymbol} from "../../symbols/TombstoneWildSymbol";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";

export class WildJailView extends BaseView {

    private _layer:ScalableLayer;
    private _locks:(TimelineSprite | null)[];

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._locks = ArrayHelper.initArrayWithValues(GameConfig.instance.REELS_NUM, () => null);
        this._layer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.WILD_JAIL.name);
    }

    public lockReel(reelId:number, mode:string, playAnimation:boolean, playSound:boolean):Timeline {
        if(this._locks[reelId] != null) {
            debugger;
            throw new Error(`WildJailView.lockReel(): Reel ${reelId} is already locked!`);
        }

        const position:[number, number] = Helper.getSymbolPositions(reelId, 1);
        const lock:TimelineSprite = new TimelineSprite(GameResources.getTextures(mode === GameMode.RESPIN ? "wildJailRespin" : "wildJailSuperFS"));
        lock.anchor.set(0.5, 0.5);
        lock.position.set(position[0], position[1]);
        this._layer.addChild(lock);
        this._locks[reelId] = lock;

        const timeline:TimelineLite = new TimelineLite();
        if(playAnimation) {
            timeline.add(lock.getAnimation());
        } else {
            timeline.add(lock.getAnimation([lock.totalFrames - 1]));
        }

        if(playSound) {
            timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.DOOR_CLOSE), 0);
        }

        return timeline;
    }

    public unlockAllReels(mode:string, isAnimated:boolean, playSound:boolean):TimelineLite {
        let hasLock:boolean = false;
        const timeline:TimelineLite = new TimelineLite();

        this._locks.forEach((lock:TimelineSprite | null, reelId:number) => {
            if(lock != null) {
                hasLock = true;
                if(mode === GameMode.RESPIN) {
                    // hide the multiplier on w.
                    const symbol:TombstoneWildSymbol = <TombstoneWildSymbol>Reels.getSymbol(reelId, 0);
                    if(symbol) {
                        timeline.add(() => symbol.updateMultiplier(0, false), 0);
                    }
                }
                if(isAnimated) {
                    timeline.add(lock.getAnimation([lock.totalFrames - 1, 0], undefined, () => {
                        lock.hide();
                        this._layer.removeChild(lock);
                        this._locks[reelId] = null;
                    }), 0);
                } else {
                    timeline.add(() => {
                        lock.hide();
                        this._layer.removeChild(lock);
                        this._locks[reelId] = null;
                    }, 0);
                }
            }
        });

        if(playSound && hasLock) {
            timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.DOOR_OPEN), 0);
        }

        return timeline;
    }
}